import { FC, useEffect, useState } from 'react';
import { useDidUpdate } from '@toss/react';
import { StarFillIcon, StarIcon } from '@zep/icons';
import { Colors } from '@zep/ui-tokens';
import S from './StarRating.module.scss';
const StarRating: FC<StarRatingProps> = ({
  starMaxCount,
  filledCount,
  isClickable = true,
  starSize = 21,
  onRateChange
}: StarRatingProps) => {
  const [selectedStarRate, setSelectedStarRate] = useState(filledCount ?? 0);

  // rating 변경마다 상위 컴포넌트로 rating 전달
  useDidUpdate(() => {
    onRateChange && onRateChange(selectedStarRate);
  }, [selectedStarRate]);
  useEffect(() => {
    setSelectedStarRate(filledCount ?? 0);
  }, [filledCount]);
  return <div className={S.star_container} style={{
    width: starSize * starMaxCount + 'px',
    height: starSize + 'px'
  }} data-sentry-component="StarRating" data-sentry-source-file="StarRating.tsx">
      <div className={S.star_wrapper}>
        <div className={S.empty_star_wrapper} style={isClickable ? {
        cursor: 'pointer'
      } : {}}>
          {Array.from({
          length: starMaxCount
        }).map((_, index) => <StarIcon key={`star-empty${index}`} width={starSize} height={starSize} fill={Colors.Gray300} onClick={() => {
          if (isClickable) {
            setSelectedStarRate(index + 1);
          }
        }} />)}
        </div>
        <div className={S.filled_star_wrapper} style={isClickable ? {
        cursor: 'pointer'
      } : {}}>
          {selectedStarRate > 0 && Array.from({
          length: selectedStarRate
        }).map((_, index) => <StarFillIcon key={`star-full${index}`} width={starSize} height={starSize} fill={Colors.PrimaryDefault} onClick={() => {
          if (isClickable) {
            setSelectedStarRate(index + 1);
          }
        }} />)}
        </div>
      </div>
    </div>;
};
export default StarRating;
export type StarRatingProps = {
  starMaxCount: number;
  filledCount?: number;
  isClickable: boolean;
  starSize?: number;
  onRateChange?: (rating: number) => void;
};